/* src/app/shared/components/form-controls/ag-checkbox/ag-checkbox.component.scss */
.relative {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
}
.relative:hover .ag-checkbox-hover-icon {
  visibility: visible;
}
.relative .ag-checkbox-hover-icon {
  padding-top: 1px;
  position: absolute;
  visibility: hidden;
  pointer-events: none;
}
.relative .ag-checkbox-checked-icon {
  padding-top: 1px;
  position: absolute;
  filter: brightness(0) invert(1);
  pointer-events: none;
}
.img-small {
  width: 9px;
  height: 9px;
}
.img-default {
  width: 10.5px;
  height: 10.5px;
}
.img-large {
  width: 16px;
  height: 16px;
}
.ag-checkbox {
  -webkit-appearance: none;
  border: solid 1px #333333;
  cursor: pointer;
  outline: none;
}
.ag-checkbox.ag-size-small {
  height: 14px;
  width: 14px;
  border-radius: 3px;
}
.ag-checkbox.ag-size-default {
  height: 19px;
  width: 19px;
  border-radius: 4px;
}
.ag-checkbox.ag-size-large {
  height: 28px;
  width: 28px;
  border-radius: 10px;
}
.ag-checkbox:hover {
  background-color: #f1f1f1;
  border-color: #61566e;
}
.ag-checkbox:focus-visible {
  border: 2px solid #61566e;
}
.ag-checkbox:checked {
  background-color: #61566e;
  border-color: #61566e;
}
.ag-checkbox.has-errors {
  border: solid 2px #d7263c;
}
.ag-checkbox.disabled {
  opacity: 0.6;
}
/*# sourceMappingURL=ag-checkbox.component.css.map */
